import { Stack, Typography, styled, type CSSObject } from '@mui/material';

export const StyledSCDDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledTypographySmall = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  maxWidth: '1300px',
  letterSpacing: '-0.02em',
  paddingBottom: theme.spacing(5),
  fontSize: '16px',
  display: 'block',
}));

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));
